import Notifications from './notifications'
import Fetch from './fetch'
import File from './file'

export default (Vue) => {
  Vue.use(Notifications)
  Vue.use(Fetch)
  Vue.use(File)
}
